/* Collection labels describe vehicles; product quantities come from Shopify. */
(() => {
  'use strict';
  const plain = s => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const compact = s => plain(s).toLowerCase().replace(/[^a-z0-9]/g, '');
  const words = s => plain(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const wordRoots=['Tri Glide','Road Glide','Street Glide','Road King','Electra Glide','Ultra Limited','Freewheeler','Street Bob','Low Rider','Fat Bob','Heritage Classic','Fat Boy','Breakout','Super Glide','Sport Glide','Wide Glide','Sportster','Nightster','Pan America','Light Bee','Varg'];
  function label(value, title = '') {
    let s = plain(value).trim().replace(/^(?:Honda|Yamaha|Kawasaki|Suzuki|KTM|Husqvarna|Husaberg|Gas[ -]?Gas|BMW|Harley[ -]Davidson|Can[ -]Am)\s+/i, '');
    s=s.replace(/^(\d{3,4})\s*ADV\b/i,'$1 Adventure');
    s=s.replace(/^(?:Stark\s+)?VARG\b/i,'Varg').replace(/^(?:SUR[- ]?RON\s+)?LIGHT\s+BEE\b/i,'Light Bee');
    const explicitAfrica = [...new Set((title.match(/CRF\s*(?:1000|1100)\s*L/ig) || []).map(compact))];
    if (/^africa\s*twin$/i.test(s) && explicitAfrica.length === 1) return explicitAfrica[0].toUpperCase();
    if (/CRF\s*(?:1000|1100)\s*L/i.test(s)) {
      s = s.replace(/africa\s*twin/ig, '').replace(/CRF\s*(1000|1100)\s*L/ig, 'CRF$1L').trim();
      const code = s.match(/CRF(?:1000|1100)L/i)?.[0];
      if (code) s = code.toUpperCase() + ' ' + s.replace(/CRF(?:1000|1100)L/i, '').trim();
    }
    if (/^(?:tenere\s*700(?:\s*(?:xtz\s*700|t700|xtz07))?|xtz\s*700|t700)$/i.test(s)) return 'Tenere 700';
    if (/^(?:banshee\s*(?:350)?\s*(?:yfz\s*350)?|yfz\s*350)$/i.test(s)) return 'Banshee 350';
    if (/^(?:blaster\s*(?:200)?\s*(?:yfs\s*200)?|yfs\s*200)$/i.test(s)) return 'Blaster 200';
    // Suzuki uses LT-Z400 / LTZ400 / QuadSport Z400 for the same ATV. Keep
    // legacy multi-name facet rows in one OR-safe canonical checkbox so the
    // Collection does not split one vehicle into competing Submodel paths.
    const suzukiZ400 = compact(s);
    if (['ltz400','quadsportz400','quadsportz400ltz400','quadsportltz400quadsportltz400z'].includes(suzukiZ400)) return 'LT-Z400';
    if (/^(?:iron\s*883\s*(?:XL883N)?|XL883N)$/i.test(s)) return 'Iron 883';
    if (/^(?:iron\s*1200\s*(?:XL1200NS)?|XL1200NS)$/i.test(s)) return 'Iron 1200';
    // Equivalent names only. Cooling generation and named trim qualifiers survive.
    if (/^[RF]\s*\d{3,4}\s*GS/i.test(s)) {
      s=s.replace(/^([RF])\s*(\d{3,4})\s*GS/i,(_,a,n)=>a.toUpperCase()+n+'GS');
      s=s.replace(/\bADV\b/ig,'Adventure');
      if (/\bLC\s+Adventure\b/i.test(s))s=s.replace(/\bLC\s+Adventure\b/i,'Adventure LC');
    }
    if (/^(?:Raptor\s*700R?\s+)?YFM\s*700R$|^Raptor\s*700R$/i.test(s))return 'Raptor 700R';
    if (/^(?:Raptor\s*700R?\s+)?YFM\s*700R(?:SE)?(?:\s+(?:SE|Special Edition))?$|^Raptor\s*700R\s+(?:SE|Special Edition)$/i.test(s) && /SE|Special Edition/i.test(s))return 'Raptor 700R SE';
    // Beta lists both family-first and displacement-first spellings.
    if (/\bBeta\b/i.test(title) || /^(?:ENDURO\s+)?(?:\d{3}\s*)?(?:RR|X[- ]?TRAINER)/i.test(s)) {
    s=s.replace(/^ENDURO\s+(?=(?:RR|RX|RS|XTRAINER))/i,'');
    let beta=s.match(/^(RR(?:-S)?|RX|RS|X[- ]?TRAINER)\s*(?:(2T|4T)\s*)?(\d{3})(.*)$/i);
    if(beta)s=beta[3]+' '+beta[1].toUpperCase().replace(/X[- ]?TRAINER/,'Xtrainer')+(beta[2]?' '+beta[2].toUpperCase():'')+beta[4];
    s=s.replace(/^(\d{3})\s*(RR(?:-S)?|RX|RS|X[- ]?TRAINER)(.*)$/i,(_,n,f,t)=>n+' '+f.toUpperCase().replace(/X[- ]?TRAINER/,'Xtrainer')+t);
    if (/^\d{3} (RR(?:-S)?|RX|RS|Xtrainer)\b/i.test(s)) {
      s=s.replace(/\(2 Stroke\)|\b2[- ]Stroke\b/ig,'2T').replace(/\(4 Stroke\)|\b4[- ]Stroke\b/ig,'4T');
      s=s.replace(/\bRACING\b|\bRACE EDITION\b/ig,'Race').replace(/\bX[- ]PRO\b/ig,'X-Pro');
      const stroke=s.match(/\b[24]T\b/i)?.[0];
      if(stroke)s=s.replace(/\s*[24]T\b/ig,'').trim()+' '+stroke.toUpperCase();
    }
    }
    // GasGas family is before displacement, with F retained as a real distinction.
    s=s.replace(/^(\d{2,3})\s*(EC|EX|MC|ES|SM|EW)\s*(F)?(?=\s|$)(.*)$/i,(_,n,f,t,tail)=>f.toUpperCase()+' '+n+(t?'F':'')+(tail.trim()?' '+tail.trim():''));
    s=s.replace(/^(EC|EX|MC|ES|SM|EW)\s*(\d{2,3})\s*(F)?(?=\s|$)(.*)$/i,(_,f,n,t,tail)=>f.toUpperCase()+' '+n+(t?'F':'')+(tail.trim()?' '+tail.trim():''));
    return s.replace(/\s+/g, ' ').trim();
  }
  function titleKeys(title) {
    const clean = String(title).replace(/\bADV\b/ig,'Adventure').replace(/\s*\/\s*/g, '/');
    const tokens = words(clean).split(' ').filter(Boolean), keys = new Set();
    for (let i=0;i<tokens.length;i++) for(let n=1;n<=6 && i+n<=tokens.length;n++) {
      const part=tokens.slice(i,i+n);
      if(part.some(t=>['for','parts','accessories','and','with'].includes(t)))break;
      keys.add(part.join(''));
      keys.add(compact(label(part.join(' '),title)));
    }
    // A slash inherits the immediately preceding vehicle, not every vehicle in the title.
    for (const m of clean.matchAll(/([A-Za-z][A-Za-z-]*\s*\d{2,4}[A-Za-z-]*|\d{2,4}\s+[A-Za-z][A-Za-z-]*(?:\s+[A-Za-z][A-Za-z-]*)?)((?:\/[A-Za-z0-9-]+)+)/g)) {
      const base=compact(m[1]);
      for(const part of m[2].split('/').filter(Boolean)) {
        const suffix=compact(part);
        if (/^\d+$/.test(suffix)) keys.add(base.replace(/\d{2,4}/,suffix));
        else if (/\d/.test(suffix)) {
          keys.add(suffix);
          const prefix=base.match(/^([a-z]+)\d/);
          if(prefix&&/^\d/.test(suffix))keys.add(prefix[1]+suffix);
        }
        else {
          keys.add(base+suffix);
          if (/^[a-z]+\d+[a-z]+$/.test(base)) keys.add(base.replace(/(\d+)[a-z]+$/,'$1')+suffix);
        }
      }
    }
    // Shared displacement, e.g. 700 SM/ES, rather than a literal SMES suffix.
    for(const m of clean.matchAll(/\b(\d{2,4})\s+([A-Za-z]+(?:\/[A-Za-z]+)+)/g))for(const f of m[2].split('/')) {
      keys.add(compact(label(m[1]+' '+f,title)));keys.add(compact(f+m[1]));
    }
    // Named families whose variants have no displacement.
    for(const m of clean.matchAll(/\b(Light Bee|Varg)\s+([A-Za-z0-9]+(?:\/[A-Za-z0-9]+)+)/ig))for(const trim of m[2].split('/'))keys.add(compact(m[1]+trim));
    // A shared family also applies to space/comma/ampersand separated
    // displacements. Do not require a slash and do not interpret ranges as lists.
    for (const m of clean.matchAll(/\b(\d{2,4}(?:(?:\s*[,/&+]\s*|\s+(?:and\s+)?)(?:\d{2,4}))+)[ ]+([A-Za-z][A-Za-z-]*(?:[ ]+[A-Za-z][A-Za-z-]*){0,2})/g)) {
      const nums = m[1].match(/\d{2,4}/g).filter(n => +n < 1900);
      const family = m[2].split(/\s+/).filter((v,i,a) => !a.slice(0,i+1).some(x => /^(?:parts|accessories|for|and|with)$/i.test(x)));
      for (const n of nums) for (let k=1;k<=family.length;k++) keys.add(compact(label(n+' '+family.slice(0,k).join(' '), title)));
    }
    // Shared letter prefix: CRF250R 450R 250X 450X (also commas and slashes).
    for (const m of clean.matchAll(/\b([A-Za-z][A-Za-z-]*)[ ]*(\d{2,4}[A-Za-z]*)(?=((?:[ ,/&+]+\d{2,4}[A-Za-z]+)+))/g)) {
      for (const tail of m[3].match(/\d{2,4}[A-Za-z]+/g) || []) keys.add(compact(m[1]+tail));
    }
    // Shared lists on both axes: 950 990 SM/Duke/ADV.
    for(const m of clean.matchAll(/\b(\d{2,4}(?:(?:\s*[,/&+]\s*|\s+)(?:\d{2,4}))+)[ ]+([A-Za-z][A-Za-z-]*(?:\/[A-Za-z][A-Za-z-]*)+)/g)) {
      for(const n of m[1].match(/\d{2,4}/g)) for(const f of m[2].split('/')) {
        keys.add(compact(label(n+' '+f,title)));
        if (/^SM$/i.test(f) && /\bKTM\b/i.test(title)) keys.add(compact(n+' Supermoto'));
      }
    }
    // Displacement-first shared family: KTM 950/990 Adventure.
    for(const m of clean.matchAll(/\b(\d{2,4}(?:\/\d{2,4})+)\s+([A-Za-z][A-Za-z-]*)/g)) {
      m[1].split('/').forEach(n=>keys.add(compact(n+m[2])));
    }
    return keys;
  }
  function classify(values, title, brands, owners) {
    const keys=titleKeys(title), named=new Set(), allowed=new Set(), eligible=new Set();
    const labels=new Map(values.map(v=>[v,label(v,title)]));
    const declared=new Set(brands || []);
    for(const v of values) {
      if(['universal','merchandise','paymentadjustment','purchaseprotection','giftcards'].includes(compact(v)))continue;
      const own=new Set(owners(v) || []);
      if(!declared.size || [...own].some(b=>declared.has(b)))eligible.add(v);
      else if(!own.size && compact(v).length>=4 && (keys.has(compact(labels.get(v)))||wordRoots.some(r=>keys.has(compact(r))&&contains(r,v,title))))eligible.add(v);
    }
    // New suffixes of an established vehicle remain usable even before a static map update.
    for(const v of values) if(!eligible.has(v) && !(owners(v)||[]).length) {
      const c=compact(labels.get(v));
      if([...eligible].some(e=>{const b=compact(labels.get(e));return b.length>=4 && c.startsWith(b) && !/^\d/.test(c.slice(b.length));}))eligible.add(v);
    }
    for(const v of eligible) if(keys.has(compact(labels.get(v))))named.add(v);
    const roots=wordRoots.filter(s=>keys.has(compact(s)));
    const normalizedTitle=words(title), titleNums=new Set((normalizedTitle.match(/\b\d{2,4}\b/g)||[]).filter(n=>+n<1900));
    const ranges=[...String(title).matchAll(/\b(\d{2,4})\s*[-–—−‑]\s*(\d{2,4})\b/g)].filter(m => {
      // 05-06 or CR125 98-99 are year shorthand, not displacement ranges.
      if (+m[1]<50 || +m[2]<50) return false;
      if (m[1].length===2 && m[2].length===2 && /\b(?:CRF?|YZ|WR|KX|KLX|RMZ?|DR-?Z?|GSX-?R?|SX|XC|EXC|TE|FE|TC|FC|TX|FX)\s*\d{2,4}/i.test(String(title).slice(0,m.index))) return false;
      return true;
    }).map(m=>[+m[1],+m[2]]).filter(([a,b])=>a<=b&&b<1900);
    const familyOf=v=>{
      const l=labels.get(v);
      const match=l.match(/^(\d{2,4})\s+([A-Za-z]+(?:-[A-Za-z]+)?)|^([A-Za-z]+(?:-[A-Za-z]+)?)\s*(\d{2,4})/);
      return match ? {n:+(match[1]||match[4]),f:compact(match[2]||match[3])} : null;
    };
    const ktmFamilies=new Set([...String(title).matchAll(/\b(EXC(?:[- ]?F)?|SX(?:[- ]?F)?|XC(?:[- ]?F)?(?:[- ]?W)?)\b/ig)].map(m=>compact(m[1])));
    const familyInTitle=f=>ktmFamilies.size && /^(?:exc|excf|sx|sxf|xc|xcf|xcw|xcfw)$/.test(f)?ktmFamilies.has(f):keys.has(f);
    const familyNamed=v=>{const x=familyOf(v);return x && familyInTitle(x.f);};
    const hasFamilyHint=[...eligible].some(familyNamed)||['adventure','duke','exc','excf','sx','sxf','xc','xcf','xcw','xcfw','rr','xtrainer','ec','ex','mc','te','fe','tc','fc'].some(familyInTitle);
    const familyTargets=new Set([...eligible].filter(v=>{
      const x=familyOf(v);
      const parentFamily={excf:'exc',sxf:'sx',xcf:'xc',xcfw:'xcw'};
      const related=x && (familyNamed(v) || (!hasFamilyHint && titleNums.size>0) || (ranges.length && parentFamily[x.f] && familyInTitle(parentFamily[x.f])));
      return x && related && (!titleNums.size || titleNums.has(String(x.n)) || ranges.some(([a,b])=>x.n>=a&&x.n<=b));
    }));
    // A range names the whole interval, not just its adjacent upper endpoint.
    // Restrict actual native values to that interval and retain named trim choices.
    if(ranges.length) {
      named.clear();
      for(const v of familyTargets) {
        const x=familyOf(v),c=compact(labels.get(v));
        if(familyNamed(v) && (c===String(x.n)+x.f || c===x.f+String(x.n)))named.add(v);
      }
      for(const v of familyTargets)allowed.add(v);
      allowed.add('Universal');
      return {allowed,priority:named,eligible,strict:true,scores:new Map([...named].map(v=>[v,1000])),labels};
    }
    // Do not bold a base merely because the title explicitly names its longer version.
    if(!title.includes('/'))for(const v of [...named]) {
      const c=compact(labels.get(v));
      if([...named].some(n=>compact(labels.get(n))!==c && compact(labels.get(n)).startsWith(c)))named.delete(v);
    }
    const declaredParent = v => {
      const l=labels.get(v), tokens=l.split(/\s+/);
      for(let i=2;i<tokens.length;i++) {
        const parent=tokens.slice(0,i).join(' ');
        if (/[a-z]/i.test(parent) && keys.has(compact(parent)) && !(ktmFamilies.size && /^(?:exc|sx|xc|xcw)$/.test(compact(tokens[i-1])) && !ktmFamilies.has(compact(tokens[i-1]))) && contains(parent,v,title) && ![...named].some(n => compact(labels.get(n))!==compact(parent) && contains(parent,n,title))) return true;
      }
      const family=l.match(/^(\d{2,4})\s+(?:Super|LC8)\s+(Adventure|Duke)\b/i);
      const parent=family ? family[1]+' '+family[2] : '';
      return !!family && keys.has(compact(parent)) && ![...named].some(n => compact(labels.get(n))!==compact(parent) && contains(parent,n,title));
    };
    for(const v of eligible) {
      const c=compact(labels.get(v));
      const rootMatch=roots.some(r=>contains(r,v,title));
      if((!named.size && (titleNums.size?familyTargets.has(v):roots.length?rootMatch:hasFamilyHint?familyTargets.has(v):true)) || declaredParent(v) || [...named].some(n=>contains(n,v,title)))allowed.add(v);
    }
    allowed.add('Universal');
    return {allowed, priority:named, eligible, strict:true, scores:new Map([...named].map(v=>[v,1000])), labels};
  }
  // A family includes its real children. A child never includes its siblings.
  function parts(value) {
    const codes=String(value).match(/\b(?:DR-?Z|CRF|YZ|KX|RM|TRX|YFM)\s*\d{2,4}[A-Z]*\b/ig)||[];
    return codes.length>1?[...new Set(codes)]:[value];
  }
  function contains(parent,child,title='') {
    const a=compact(label(parent,title)),b=compact(label(child,title));
    if(a===b)return true;
    if(!/\d/.test(a)) {
      const aa=words(label(parent,title)),bb=words(label(child,title));
      return aa.length>=4 && (' '+bb+' ').includes(' '+aa+' ');
    }
    if(/^[a-z]+\d{2,4}$/.test(a))return b.startsWith(a)&&/^[a-z]/.test(b.slice(a.length));
    // The generic family includes its named Super/LC8 variants, preserving
    // their separate labels and exact child selections.
    const family = a.match(/^(\d{2,4})(adventure|duke)$/);
    if (family && new RegExp('^'+family[1]+'(?:super|lc8)'+family[2]+'(?:[a-z]|$)').test(b)) return true;
    const supermoto = a.match(/^(950|990)supermoto$/);
    if (supermoto && new RegExp('^'+supermoto[1]+'sm[rt]?$').test(b)) return true;
    const beta=a.match(/^(\d{3})rr$/);
    if(beta)return b.startsWith(a)&&/^(?:2t|4t|race|xpro|s)/.test(b.slice(a.length));
    const rawA=label(parent,title).toLowerCase(),rawB=label(child,title).toLowerCase();
    return rawB.startsWith(rawA+' ');
  }
  const parents=(values,title)=>wordRoots.filter(r=>!(String(title).match(/\b\d{2,4}\b/g)||[]).some(n=>+n<1900)&&titleKeys(title).has(compact(r))&&!values.some(v=>compact(label(v,title))===compact(r))&&values.some(v=>contains(r,v,title)));
  window.NICECNCFacetPolicy={compact,label,titleKeys,classify,parts,contains,parents};
})();
